module.exports = "/_next/static/images/Antenna-6a4f983895667ed2dcf83317e1e5bc36.png";